import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import "./AdmissionPage.css";
import PropTypes from "prop-types";

const AdmissionPage = ({ onProceed }) => {
  const [admissionType, setAdmissionType] = useState("");
  const [admissionNumber, setAdmissionNumber] = useState("");
  const [admissionTypeError, setAdmissionTypeError] = useState("");
  const [admissionNumberError, setAdmissionNumberError] = useState("");
  const navigate = useNavigate();

  const handleProceed = async () => {
    let hasError = false;
    if (admissionType !== "admission") {
      setAdmissionTypeError("You can only choose Admission Type.");
      hasError = true;
    }
    if (!admissionNumber) {
      setAdmissionNumberError("Please enter a valid Admission Number.");
      hasError = true;
    }

    if (!hasError) {
      try {
        const dupResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/ladyirwin-api/duplicateTransactionStatus/${admissionNumber}`,
          { method: "POST" }
        );

        if (!dupResponse.ok) {
          throw new Error(
            `Failed to check duplicate transaction status: ${dupResponse.status}`
          );
        }

        const dupResult = await dupResponse.json();

        if (dupResult.duplicateStatus.transaction_status === "SUCCESS") {
          setAdmissionNumberError(
            "This admission number has already completed the transaction."
          );
          return;
        }
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/ladyirwin-api/fetch-student-data/${admissionNumber}`,
          {
            method: "POST",
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch student data");
        }
        const result = await response.json();

        onProceed({ admissionType, admissionNumber, studentData: result.data });
        navigate("/ladyirwin/form");
      } catch (error) {
        console.error("Error fetching student data:", error);
        setAdmissionNumberError(
          "Could not fetch student data. Please check the admission number."
        );
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="admission-container">
        <div className="admission-box">
          <h2>Student Identification</h2>
          <br />
          <div className="form-group">
            <label>
              Admission Type: <span style={{ color: "red" }}>*</span>
              <select
                value={admissionType}
                onChange={(e) => setAdmissionType(e.target.value)}
                className="ad-control"
              >
                <option value="">Choose your option</option>
                <option value="annual">Annual</option>
                <option value="hostel">Hostel</option>
                <option value="admission">Admission</option>
              </select>
            </label>
            {admissionTypeError && (
              <div className="error-message">{admissionTypeError}</div>
            )}
          </div>
          <br />
          <div className="form-group">
            <label>
              Admission Number: <span style={{ color: "red" }}>*</span>
              <input
                type="text"
                value={admissionNumber}
                onChange={(e) => setAdmissionNumber(e.target.value)}
                className="ad-control"
                placeholder="Enter valid admission number"
              />
            </label>
            {admissionNumberError && (
              <div className="error-message">{admissionNumberError}</div>
            )}
          </div>
          <br />
          <button className="proceed-button" onClick={handleProceed}>
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

AdmissionPage.propTypes = {
  onProceed: PropTypes.func.isRequired,
};

export default AdmissionPage;

